import Clarity from '@microsoft/clarity';

const DEFAULT_PROJECT_ID = 'x1otzypmlq';

let initialized = false;

export const initClarity = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID || DEFAULT_PROJECT_ID;
  if (!projectId || initialized || typeof window === 'undefined') {
    return;
  }
  Clarity.init(projectId);
  initialized = true;
};

export const setClarityTags = (tags: Record<string, string | number | boolean | undefined | null>) => {
  if (!initialized) {
    initClarity();
  }
  Object.entries(tags).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    Clarity.setTag(key, String(value));
  });
};

export const trackClarityPage = (
  pageId: string,
  tags: Record<string, string | number | boolean | undefined | null> = {},
  customId?: string,
) => {
  if (!initialized) {
    initClarity();
  }
  setClarityTags({
    page: pageId,
    path: window.location.pathname,
    env: window.env,
    ...tags,
  });
  if (customId) {
    Clarity.identify(customId, undefined, pageId);
  }
  Clarity.event(`page:${pageId}`);
};

export const trackClarityEvent = (
  eventName: string,
  tags: Record<string, string | number | boolean | undefined | null> = {},
) => {
  if (!initialized) {
    initClarity();
  }
  setClarityTags(tags);
  Clarity.event(eventName);
};
